<mat-accordion>
  @if (descriptions.length>0) {
  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title> DETAILS </mat-panel-title>
    </mat-expansion-panel-header>
    <ul>
      @for (description of descriptions; track $index) {
      <li>
        <p>{{description}}</p>
      </li>
      }
    </ul>
  </mat-expansion-panel>
  }
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title> Free 30-Day Returns </mat-panel-title>
    </mat-expansion-panel-header>
    <ul>
      <li>
        Free exchanges are available within 30 days for eligible items in
        resellable condition. If your item arrives damaged, defective, or with
        an issue caused by us, we’ll issue a refund directly — no return
        required. Final Sale items cannot be returned or exchanged.
      </li>
      <li>
        You can find additional information about our
        <a
          routerLink="/return-and-exchange-policy"
          aria-label="Return & Exchange Policy"
          >Return & Exchange Policy</a
        >
        .
      </li>
    </ul>
  </mat-expansion-panel>
</mat-accordion>
